//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const HideCommenterFullName: FeatureFlag = {"Id":"HideCommenterFullName","Label":"Hide Commenter Full Name","Impact":"Hide the commenter name from visitors","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
